import { CountyData } from "../types/County";
import { patientApiUrl } from "./api";

const API_URL = "/Counties";

export const getData = async (): Promise<CountyData[]> => {
  try {
    const res = await patientApiUrl.get<CountyData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all countries error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<CountyData | null> => {
  try {
    const res = await patientApiUrl.get<CountyData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get country error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};
